import { useIntl } from 'react-intl';

import { PaidHeroTabPanelTemplate } from './hero-tab-panel-template';

const SalesTabContent = () => {
	const intl = useIntl();

	const salesHeroProps = {
		header: intl.formatMessage({
			id: 'JiraSoftwarePagePaidLpJswFeatures.hero.sales.header',
			defaultMessage: 'Hit sales team targets with Jira',
		}),
		image: {
			src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/87h6hy3p184v1kyn202mov58b5y6q82d.webp',
			alt: intl.formatMessage({
				id: 'JiraSoftwarePagePaidLpJswFeatures.sales.heroImageAlt',
				defaultMessage: 'Screen capture of a Jira board for a product launch',
			}),
		},
	};

	return <PaidHeroTabPanelTemplate {...salesHeroProps} />;
};

export default SalesTabContent;
